( function($) {

	var app = {

		initCustomFunction: function(){
			$('.ip-support-option-button-list .button-option').on('click', function(){
				$('.ip-support-option-button-list .button-option').removeClass('active');
				$(this).addClass('active');
			});
			$('.ip-support-cta-btn .button-item').on('click', function(){
				$('.ip-support-cta-btn .button-item').removeClass('active');
				$(this).addClass('active');
			});

          if( $('#shopify-section-support-faq-list .ip-support-faq-col').length > 0 ) {

            var divs = $('#shopify-section-support-faq-list .ip-support-faq-col');
            
            for(var i = 0; i < divs.length; i+=3) {
            
              divs.slice(i, i+3).wrapAll('<div class="ip-support-faq-row"></div>');
            }
          }
		},
	}

	
	$(document).ready( function() {
		app.initCustomFunction();
	});
	
	$(window).on('load', function(){

	});

})(jQuery);